import React from 'react';
import deliveryImg from '../../images/sections/demata.webp';

const DeliverySection = ({ t }) => {
  return (
    <section className="delivery" id="delivery">
      <div className="delivery__image">
        <img src={deliveryImg} alt="Παράδοση προϊόντων" />
      </div>
      <div className="delivery__content">
        <h2>{t.delivery.title}</h2>
        <div className="delivery__pill">
          <span className="delivery__icon" aria-hidden="true" />
          <p>{t.delivery.body}</p>
        </div>
      </div>
    </section>
  );
};

export default DeliverySection;
